import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-rating',
    templateUrl: './rating.component.html'
})

export class RatingComponent {
    @Input() rate: number;
    @Input() ratingType: 'star' | 'diagram' | 'bar_diagram' = 'star';
    @Input() color: 'danger' | 'green' | 'yellow' = 'danger';

    public getDiagramClass(): string {        
        const rateClass = `rating-${this.rate + 3}`;
        switch (this.rate + 3) {
            case 1 :
                return `${rateClass} danger`;
            case 2 :
                return `${rateClass} hight`;
            case 3 :
                return `${rateClass} medium`;
            case 4 :
                return `${rateClass} low`;
            case 5 :
                return `${rateClass} safe`;
            default :
                return 'rating-1 danger';
        }


    }
    public getBarDiagramClass():string{
        return `rating-5 ${this.color}`
    }
}
